import { SignYieldIcon } from './SignYieldIcon';

/**
 * author: Michael Irigoyen
 * id C325938C-B13A-47A1-BD51-7F6F34B6CE16
 * name sign-yield
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sign-yield.svg
 * tags
 * - Transportation + Road 
 */
export const GiveWayIcon = SignYieldIcon;
export default GiveWayIcon